
import { Vue, Component } from "vue-property-decorator";
import { capitalizeFirst } from "@/utils";
import { IInstructor, IUser } from "@/schemas/IUser";
import { ISequence } from "@/schemas/ISequence";
import SequenceForm from "@/components/admin/entityForm/SequenceForm.vue";
import TipGroupForm from "@/components/admin/entityForm/TipGroupForm.vue";
import ActivityForm from "@/components/admin/entityForm/ActivityForm.vue";
import { mapGetters, mapState } from "vuex";

@Component({
  computed: {
    ...mapState("user", ["users"]),
    ...mapGetters("user", ["isAdministrator"]),
  },
})
export default class registerAdminPage extends Vue {
  data(): any {
    return {
      headers: [
        {
          text: "Nom de la séquence",
          align: "start",
          sortable: false,
          value: "title",
        },
        { text: "Academie de l'auteur·ice", value: "email" },
        { text: "Nombre d'activités", value: "total_activities" },
        { text: "Date de création", value: "created_at" },
      ],
      editedIndex: -1,
      moduleList: [],
      sortBy: "created_at",
      sortDesc: true,
    };
  }

  exportAnalytics(): void {
    let today = new Date();
    let options = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    };
    const data = this.moduleList;
    const content = data.map((e) => [
      e.title,
      e.email,
      e.total_activities,
      e.created_at,
    ]);
    const csvContent =
      "Nom de la séquence, Academie, Nombre d'activités, Date de création\n" +
      content.map((e) => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const link = document.createElement("a");
    link.setAttribute("href", window.URL.createObjectURL(blob));
    link.setAttribute(
      "download",
      `export_sequence_${today
        .toLocaleDateString("fr-FR", options)
        .replaceAll("/", "-")}.csv`
    );
    link.click();
  }

  created() {
    this.$store.dispatch("sequence/sequenceLogGet", {
      next: (response) => {
        response.sort(this.compare);

        for (let i = 0; i < response.length; i++) {
          let index = response[i].email.indexOf("@");
          response[i].email = response[i].email.slice(
            index + 1,
            response[i].email.length
          );
          let index2 = response[i].email.indexOf(".");
          response[i].email = response[i].email.slice(0, index2);
          response[i].created_at = response[i].created_at.slice(0, 10);
        }

        this.moduleList = response;
      },
    });
  }

  compare(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }
}
//
//
